import React, { useState } from 'react';
import { ref, get } from 'firebase/database';
import { database } from '../firebase';
import './ApplicationInquiry.css';

const ApplicationInquiry = ({ onClose }) => {
  const [id, setId] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const getStatusLabel = (status) => {
    if (status === 'approved') return 'Onaylandı - Aktif Üye';
    if (status === 'rejected') return 'Reddedildi';
    return 'Beklemede';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = (id || '').trim();
    if (!trimmed) {
      setError('Lütfen başvuru numaranızı girin.');
      setResult(null);
      return;
    }
    setError('');
    setResult(null);
    setLoading(true);
    try {
      const appRef = ref(database, `membershipApplications/${trimmed}`);
      const snapshot = await get(appRef);
      if (snapshot.exists()) {
        const data = snapshot.val();
        const status = data.status === 'approved' || data.status === 'rejected' ? data.status : 'pending';
        setResult({ status, fullName: data.fullName });
      } else {
        setResult({ notFound: true });
      }
    } catch (err) {
      setError(err.message || 'Sorgulama sırasında bir hata oluştu.');
      setResult(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="application-inquiry-overlay" onClick={onClose}>
      <div className="application-inquiry-modal" onClick={(e) => e.stopPropagation()}>
        <div className="application-inquiry-header">
          <h2>Başvuru Sorgula</h2>
          <button type="button" className="application-inquiry-close" onClick={onClose} aria-label="Kapat">
            ×
          </button>
        </div>
        <p className="application-inquiry-desc">
          Online üyelik başvurunuzu tamamladıktan sonra size verilen başvuru numarasını aşağıya girerek başvuru durumunuzu öğrenebilirsiniz.
        </p>
        <form onSubmit={handleSubmit} className="application-inquiry-form">
          <label htmlFor="inquiry-id">Başvuru numarası</label>
          <input
            id="inquiry-id"
            type="text"
            value={id}
            onChange={(e) => setId(e.target.value)}
            placeholder="Başvuru numaranızı yapıştırın"
            disabled={loading}
            autoComplete="off"
          />
          {error && <p className="application-inquiry-error">{error}</p>}
          <button type="submit" className="application-inquiry-submit" disabled={loading}>
            {loading ? 'Sorgulanıyor…' : 'Sorgula'}
          </button>
        </form>
        {result && (
          <div className={`application-inquiry-result result-${result.notFound ? 'notfound' : result.status}`}>
            {result.notFound ? (
              <>
                <p className="result-title">Başvuru bulunamadı</p>
                <p className="result-text">Girdiğiniz numaraya ait bir başvuru kaydı bulunamadı. Lütfen numarayı kontrol edip tekrar deneyin.</p>
              </>
            ) : (
              <>
                <p className="result-title">Başvuru durumunuz</p>
                <p className="result-status">{getStatusLabel(result.status)}</p>
                {result.fullName && <p className="result-name">{result.fullName}</p>}
                {result.status === 'pending' && (
                  <p className="result-text">Başvurunuz incelemeye alınmıştır. Değerlendirme tamamlandığında bu sayfadan tekrar sorgulayarak sonucu öğrenebilirsiniz.</p>
                )}
                {result.status === 'approved' && (
                  <p className="result-text">Üyelik başvurunuz onaylanmıştır. Detaylar için tarafınıza dönüş yapılacaktır.</p>
                )}
                {result.status === 'rejected' && (
                  <p className="result-text">Üyelik başvurunuz reddedilmiştir. Sorularınız için lütfen bizimle iletişime geçin.</p>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ApplicationInquiry;
